import { cn } from 'src/lib/utils';

type LoaderSize = 'small' | 'default' | 'large';

const sizeConfig: Record<LoaderSize, { size: string; stroke: string }> = {
  small: { size: '20px', stroke: '1px' },
  default: { size: '30px', stroke: '2px' },
  large: { size: '50px', stroke: '3px' },
};

const LINE_COUNT = 12;

export default function Loader({ size = 'default', className }: { size?: LoaderSize; className?: string }) {
  const wrapperClasses = cn('flex justify-center items-center h-full w-full', className);
  const { size: uibSize, stroke: uibStroke } = sizeConfig[size];

  return (
    <div className={wrapperClasses} role="alert">
      <div
        className="relative flex items-center justify-start"
        style={
          {
            height: uibSize,
            width: uibSize,
            '--loader-speed': '1s',
            '--loader-stroke': uibStroke,
          } as React.CSSProperties
        }
      >
        {Array.from({ length: LINE_COUNT }, (_, i) => {
          const index = i + 1;
          return (
            <div
              key={index}
              className="absolute top-0 flex h-full items-start"
              style={{
                left: 'calc(50% - var(--loader-stroke) / 2)',
                width: 'var(--loader-stroke)',
                transform: `rotate(calc(360deg / -12 * ${index}))`,
              }}
            >
              <div
                className="h-[22%] w-full bg-foreground transition-colors duration-300"
                style={{
                  borderRadius: 'calc(var(--loader-stroke) / 2)',
                  transformOrigin: 'center bottom',
                  animation: 'loader-pulse var(--loader-speed) ease-in-out infinite',
                  animationDelay: `calc(var(--loader-speed) / -12 * ${index})`,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
